export var defaultState = {
  rowOrColumnMoved: {
    type: undefined,
    numberOfCells: undefined,
    currentActions: []
  }
};